import { createSelector } from 'reselect';
import { RootState } from 'src/store';

const getDescription = (state: RootState) => state.pages.editor.scene.description;

const getSceneDescription = createSelector([getDescription], (description) => description);

export default getSceneDescription;
